import React, { useRef, useState } from 'react';
import './App.css';

import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent  } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore, collection, addDoc, query, orderBy, limitToLast } from "firebase/firestore";
import { serverTimestamp } from 'firebase/firestore'

import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/analytics';

import { useAuthState } from 'react-firebase-hooks/auth';
import { useCollectionData } from 'react-firebase-hooks/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDWWqhQyWR-zYTlQ1TwJKZchi-jMSY8iDk",
  authDomain: "nkart-a5f3d.firebaseapp.com",
  projectId: "nkart-a5f3d",
  storageBucket: "nkart-a5f3d.appspot.com",
  messagingSenderId: "54929643327",
  appId: "1:54929643327:web:b09d0e334675b74a5d258a",
  measurementId: "G-HGHJ6EDDMY"
};

const base = initializeApp(firebaseConfig);
const analytics = getAnalytics(base);
const auth = getAuth(base);
const db = getFirestore(base);


function App() {

  const [user] = useAuthState(auth);

  

  return (
    <div className="App">
      <header>
        <h2>nka</h2>
        <SignOut />
      </header>

      <section>
        {user ? <ChatRoom /> : <SignIn />}
      </section>

    </div>
  );
}

function SignIn() {

  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider);
    // analytics.setUserId(auth.currentUser.uid);
    logEvent(analytics, 'log in');
  }

  return (
    <>
      <button className="sign-in" onClick={signInWithGoogle}>Sign in with Google</button>
    </>
  )

}

function SignOut() {
  logEvent(analytics, 'log out');
  return auth.currentUser && (
    <button className="sign-out" onClick={() => auth.signOut()}>Sign Out</button>
  )
}

function ChatRoom() {

  logEvent(analytics, 'Chat_room');

  const dummy = useRef();
  const roomRef = collection(db, 'room', auth.currentUser.uid, 'chats');
  const [formValue, setFormValue] = useState('');

  const q = query(roomRef, orderBy('createdAt'), limitToLast(25))
  const [messages] = useCollectionData(q, { idField: 'id' });
  

  const sendMessage = async (e) => {
    e.preventDefault();

    const { uid, photoURL } = auth.currentUser;

    console.log(formValue)
    await addDoc(roomRef, {
      text: formValue,
      createdAt: serverTimestamp(),
      uid,
      photoURL,
      read: false
    })

    setFormValue('');
    dummy.current.scrollIntoView({ behavior: 'smooth' });
    logEvent(analytics, 'send_message');
  }

  return (<>
  <p> welcome to nka</p>

  <main>

      {messages && messages.map(msg => <ChatMessage key={msg.id} message={msg} />)}

      <span ref={dummy}></span>

    </main>

  <form onSubmit={sendMessage}>

      <input value={formValue} onChange={(e) => setFormValue(e.target.value)} placeholder="say something nice" />

      <button type="submit" disabled={!formValue}>🚀</button>

    </form>
  </>)
}

function ChatMessage(props) {
  const { text, uid, photoURL, messageType, data } = props.message;

  const messageClass = uid === auth.currentUser.uid ? 'sent' : 'received';

  const renderElement = () =>{
    console.log(messageType)
    if(messageType==='product'){
      return (
      <div>
        <p><b>{data.store}</b></p>
        <p>{data.name}</p>
        <img src={data.img} alt={data.img}/>
        <p><b>₹ {data.price}</b></p>
        <p>{data.rating} | ({data.r_total})</p>
        <a href={data.url} target="_blank"><button>Click to buy</button></a>
      </div>
      );
    }else{
      return <p>{text}</p>;
    }
  }

  return (<>
    <div className={`message ${messageClass}`}>
      <img src={photoURL || '/ico.svg'} alt={photoURL}/>
      { renderElement() }
    </div>
  </>)
}
export default App;
